import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana13Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_33445)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M714.507 561.148L675.762 533.799L616.504 615.848L652.97 638.639C660.567 639.399 675.306 640.463 682.599 638.639C689.892 636.816 707.669 599.134 716.786 579.382L714.507 561.148Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M621.059 497.331L675.758 533.797L616.501 615.846L564.081 581.659L621.059 497.331Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M491.144 638.638H650.684L541.285 567.984L491.144 638.638Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M504.815 540.635L561.794 581.659L621.051 497.331L575.469 469.981L504.815 540.635Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M491.153 638.634L541.294 567.981L504.828 540.631L409.104 638.634H491.153Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M311.094 638.638H409.097L427.332 620.405L361.237 556.589L299.698 618.126C296.051 629.065 305.776 636.359 311.094 638.638Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M409.096 508.726L361.234 556.587L427.329 620.403L475.191 572.541L409.096 508.726Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M523.061 522.4L475.199 572.541L409.104 508.725L456.966 458.584L523.061 522.4Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M491.145 424.398L456.958 458.585L523.053 522.401L575.473 469.981C556.48 457.066 516.671 429.868 509.378 424.398C502.085 418.928 494.184 422.119 491.145 424.398Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_33445" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_33445" transform="matrix(0.00312622 0 0 0.00414453 -7.5682 -1.46787)"/>
    </pattern>
    <image id="image0_1466_33445" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};